export const getNewRange = ({
  currRange,
  loadPrev = false,
  PAGINATION_LIMIT = 10
}) => {
  let newRange = []
  if (!currRange) {
    newRange = [0, PAGINATION_LIMIT - 1]
  } else {
    const init = loadPrev ? currRange[0] - PAGINATION_LIMIT : currRange[1] + 1
    const ends = loadPrev
      ? currRange[1] - PAGINATION_LIMIT
      : currRange[1] + PAGINATION_LIMIT

    newRange = [init, ends]
  }

  return newRange
}
